module.exports = __webpack_public_path__ + "media/app/assets/mailers/email-48-primary-5ee33e8f0e158087f8916c3721740132.png";